import React, {Component} from 'react';

class WideFacilityCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            now: Date.now()
        };
    }

    componentDidMount() {
        this._mounted = true;
        // Force to rerender every minute so the times update
        this.setState({
            rerenderTimer: setInterval(() => this.setState({now: Date.now()}), 60*1000)
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.rerenderTimer);
    }

    render() {
        const {facility, activeDevices, patientsAtRisk, alertCount, section} = this.props;

        return (
            <div className='col-md-4'>
                { this._mounted &&
                    <div className='card' onClick={() => this.props.history.push(`/facilities/${facility}/sections/${section}/rooms`)}>
                        <CardHeader name={facility} />
                        <div className='facility-card-body'>
                            <div className='facility-card-item'>
                                <span className='label proper-padding'>Active Devices</span>
                                <div className='value proper-padding'>
                                    <span className='facility-strong-value'> {activeDevices.active}</span> /{activeDevices.total}
                                </div>
                                <span className='label proper-padding'>Patients At Risk</span>
                                <div className='value proper-padding'>
                                    <span className='facility-strong-value'>{patientsAtRisk}</span>
                                </div>
                            </div>
                            <div className='facility-card-item facility-separator'>
                                <span className='label'>Alerts</span>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="alert-box-detail"><span
                                            className="facility-alert-total alert-urgent-keenly">{alertCount.urgent}</span> Urgent
                                        </div>
                                        <div className="alert-box-detail"><span
                                            className="facility-alert-total alert-warning-keenly">{alertCount.warning}</span> Warning
                                        </div>
                                        <div className="alert-box-detail"><span
                                            className="facility-alert-total alert-general-keenly">{alertCount.general}</span> General
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const CardHeader = ({name}) => (
    <div className='card-header d-flex justify-content-between'>
        <span>{name}</span>
    </div>
);

export default WideFacilityCard;
